/* PROTOCOL · renewal page baseline line  (28 Sep 2026)

   protocol-renewal.js writes "Everything was in range last time. This panel is
   where that becomes a trend." whenever a member's link carries no markers
   (mk empty). An audit on 28 Sep found that claim false for 29 of the 32
   members it applied to: the original link builder read whichever lab file
   came first, often a small follow-up or an InBody scan, not the annual panel.

   Links now carry real markers wherever the annual panel had flags that map to
   a theme. The few that stay empty are either verified in range or had flags
   that fit no theme, and for those we cannot honestly say "in range". This
   replaces the sentence with one that is true for every member.

   Text-only swap, runs for three seconds after load to catch the late render,
   touches nothing else. Delete this file and its tag to revert. */
(function () {
  'use strict';
  var A = 'Everything was in range last time.', A2 = 'Your first panel set your baseline.';
  var B = 'This panel is where that becomes a trend.', B2 = 'This one shows what has changed.';
  function fix() {
    var w = document.createTreeWalker(document.body || document.documentElement, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue;
      if (v.indexOf(A) > -1 || v.indexOf(B) > -1) n.nodeValue = v.split(A).join(A2).split(B).join(B2);
    }
  }
  var t = 0, iv = setInterval(function () { fix(); if (++t > 15) clearInterval(iv); }, 200);
  document.addEventListener('DOMContentLoaded', fix);
})();
